<template>
    <div class="container py-5">
      <h2>Our Services</h2>
      <p>We offer professional rehabilitation and support services.</p>
    </div>
  </template>
  